"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.performFirstTokenRequestAsync = exports.performAuthorizationRequestAsync = exports.performTokenRequestAsync = exports.performRevocationRequestAsync = exports.TOKEN_TYPE = exports.fetchFromIssuer = void 0;
const cache_js_1 = require("./cache.js");
const crypto_js_1 = require("./crypto.js");
const oidc_js_1 = require("./oidc.js");
const parseTokens_js_1 = require("./parseTokens.js");
const oneHourSecond = 60 * 60;
const fetchFromIssuer = (fetch) => (openIdIssuerUrl, timeCacheSecond = oneHourSecond, storage = window.sessionStorage, timeoutMs = 10000) => __awaiter(void 0, void 0, void 0, function* () {
    const fullUrl = `${openIdIssuerUrl}/.well-known/openid-configuration`;
    const localStorageKey = `oidc.server:${openIdIssuerUrl}`;
    const data = (0, cache_js_1.getFromCache)(localStorageKey, storage, timeCacheSecond);
    if (data) {
        return new oidc_js_1.OidcAuthorizationServiceConfiguration(data);
    }
    const response = yield internalFetch(fetch)(fullUrl, {}, timeoutMs);
    if (response.status !== 200) {
        return null;
    }
    const result = yield response.json();
    (0, cache_js_1.setCache)(localStorageKey, result, storage);
    return new oidc_js_1.OidcAuthorizationServiceConfiguration(result);
});
exports.fetchFromIssuer = fetchFromIssuer;
const internalFetch = (fetch) => (url, headers = {}, timeoutMs = 10000, numberRetry = 0) => __awaiter(void 0, void 0, void 0, function* () {
    let response;
    try {
        const controller = new AbortController();
        setTimeout(() => controller.abort(), timeoutMs);
        response = yield fetch(url, Object.assign(Object.assign({}, headers), { signal: controller.signal }));
    }
    catch (e) {
        if (e.name === 'AbortError' ||
            e.message === 'Network request failed') {
            if (numberRetry <= 1) {
                return yield internalFetch(fetch)(url, headers, timeoutMs, numberRetry + 1);
            }
            else {
                throw e;
            }
        }
        else {
            console.error(e.message);
            throw e; // rethrow other unexpected errors
        }
    }
    return response;
});
exports.TOKEN_TYPE = {
    refresh_token: 'refresh_token',
    access_token: 'access_token',
};
const performRevocationRequestAsync = (fetch) => (url, token, token_type = exports.TOKEN_TYPE.refresh_token, client_id, timeoutMs = 10000) => __awaiter(void 0, void 0, void 0, function* () {
    const details = {
        token,
        token_type_hint: token_type,
        client_id,
    };
    const formBody = [];
    for (const property in details) {
        const encodedKey = encodeURIComponent(property);
        const encodedValue = encodeURIComponent(details[property]);
        formBody.push(`${encodedKey}=${encodedValue}`);
    }
    const formBodyString = formBody.join('&');
    const response = yield internalFetch(fetch)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: formBodyString,
    }, timeoutMs);
    if (response.status !== 200) {
        return { success: false };
    }
    return {
        success: true,
    };
});
exports.performRevocationRequestAsync = performRevocationRequestAsync;
const performTokenRequestAsync = (fetch) => (url, details, extras, oldTokens, tokenRenewMode, timeoutMs = 10000) => __awaiter(void 0, void 0, void 0, function* () {
    for (const [key, value] of Object.entries(extras)) {
        if (details[key] === undefined) {
            details[key] = value;
        }
    }
    const formBody = [];
    for (const property in details) {
        const encodedKey = encodeURIComponent(property);
        const encodedValue = encodeURIComponent(details[property]);
        formBody.push(`${encodedKey}=${encodedValue}`);
    }
    const formBodyString = formBody.join('&');
    const response = yield internalFetch(fetch)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: formBodyString,
    }, timeoutMs);
    if (response.status !== 200) {
        return { success: false, status: response.status };
    }
    const tokens = yield response.json();
    return {
        success: true,
        data: (0, parseTokens_js_1.parseOriginalTokens)(tokens, oldTokens, tokenRenewMode),
    };
});
exports.performTokenRequestAsync = performTokenRequestAsync;
const performAuthorizationRequestAsync = (storage) => (url, extras) => __awaiter(void 0, void 0, void 0, function* () {
    extras = extras ? Object.assign({}, extras) : {};
    const codeVerifier = (0, crypto_js_1.generateRandom)(128);
    const codeChallenge = yield (0, crypto_js_1.deriveChallengeAsync)(codeVerifier);
    yield storage.setCodeVerifierAsync(codeVerifier);
    yield storage.setStateAsync(extras.state);
    extras.code_challenge = codeChallenge;
    extras.code_challenge_method = 'S256';
    let queryString = '';
    if (extras) {
        for (const [key, value] of Object.entries(extras)) {
            if (queryString === '') {
                queryString += '?';
            }
            else {
                queryString += '&';
            }
            queryString += `${key}=${encodeURIComponent(value)}`;
        }
    }
    window.location.href = `${url}${queryString}`;
});
exports.performAuthorizationRequestAsync = performAuthorizationRequestAsync;
const performFirstTokenRequestAsync = (storage) => (url, extras, tokenRenewMode, timeoutMs = 10000) => __awaiter(void 0, void 0, void 0, function* () {
    extras = extras ? Object.assign({}, extras) : {};
    extras.code_verifier = yield storage.getCodeVerifierAsync();
    const formBody = [];
    for (const property in extras) {
        const encodedKey = encodeURIComponent(property);
        const encodedValue = encodeURIComponent(extras[property]);
        formBody.push(`${encodedKey}=${encodedValue}`);
    }
    const formBodyString = formBody.join('&');
    const response = yield internalFetch(fetch)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: formBodyString,
    }, timeoutMs);
    yield Promise.all([storage.setCodeVerifierAsync(null), storage.setStateAsync(null)]);
    if (response.status !== 200) {
        return { success: false, status: response.status };
    }
    const tokens = yield response.json();
    return {
        success: true,
        data: {
            state: extras.state,
            tokens: (0, parseTokens_js_1.parseOriginalTokens)(tokens, null, tokenRenewMode),
        },
    };
});
exports.performFirstTokenRequestAsync = performFirstTokenRequestAsync;
//# sourceMappingURL=requests.js.map